import { type ReactNode } from "react";
import styles from "./PosterScrollContainer.module.css";
import classNames from "classnames";

//#region [Props]
type PosterScrollContainerProps = {
    children: ReactNode;
    containerClassName?: string;
    displayClassName?: string;
};
//#endregion

//#region [Component]
export default function PosterScrollContainer({ children, containerClassName, displayClassName }: PosterScrollContainerProps) {
    return <div className={classNames(styles.PosterScrollContainer, containerClassName)}>
        <div className={classNames(styles.PosterScrollDisplay, displayClassName)}>
            {children}
        </div>
    </div>;
}
//#endregion
